import NavBar from './nav-bar.container';

export default NavBar;
